<div [ngClass]="{ 'error-min-h': standAloneForm }">
    <p class="emd-input-feedback _state_error">{{ getErrorMessage() }}</p>
</div>
